import { Alert, AlertProps, createStyles, useMantineTheme } from "@mantine/core";
import { IconV3 } from "../icons/IconV3";

const useRpiAlertStyles = createStyles((theme) => ({
  root: {
    background: theme.other.semanticColors.alertDangerBackground,
    color: theme.other.semanticColors.textBold,
    borderRadius: theme.radius.sm,
    padding: theme.spacing.xs,
    // Hack - icon needs to manually center based on line-height so that it's always
    // aligned with the top line of text.
    "--line-height": "20px",
  },
  message: {
    color: "unset",
    fontSize: theme.fontSizes.sm,
    lineHeight: "var(--line-height)",
  },
  errorContainer: {
    display: "flex",
    gap: 4,
    alignItems: "start",
  },
  iconContainer: {
    height: "var(--line-height)",
    display: "flex",
    alignItems: "center",
  },
}));

export interface RpiAlertProps extends Omit<AlertProps, "icon"> {
  showIcon?: boolean;
}

export function RpiAlert({ showIcon = true, children, ...props }: RpiAlertProps) {
  const { classes } = useRpiAlertStyles();
  const theme = useMantineTheme();

  const content = showIcon ? (
    <div className={classes.errorContainer}>
      <div className={classes.iconContainer}>
        <IconV3 icon="error" size={16} color={theme.other.semanticColors.alertDangerBorder} />
      </div>
      <div className={classes.message}>{children}</div>
    </div>
  ) : (
    children
  );

  return (
    <Alert classNames={classes} {...props}>
      {content}
    </Alert>
  );
}
